import React from "react";
import { List, Label } from "semantic-ui-react";
const CentersList = ({ centers, handleCenterClick }) => {
	return (
		<div>
			Centres :
			<List link bulleted horizontal>
				{centers.map((center) => (
					<List.Item key={center.id} onClick={() => handleCenterClick(center.id)}>
						<Label>{center.name}</Label>
					</List.Item>
				))}
			</List>
		</div>
	);
};

export default CentersList;
